module.exports = __webpack_public_path__ + "static/media/Thread.df8f770f.svg";